module.exports = __webpack_public_path__ + "img/back.26df9036.svg";